import React, { Component } from 'react';
import BodyMovin from 'bodymovin';

function wrapperStyle({ visible, size }) {
  return {
    width: size,
    transition: 'opacity 600ms ease-in-out',
    opacity: visible ? 1 : 0
  };
}

class AnimatedSVG extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props
    };
  }

  componentDidMount() {
    BodyMovin.loadAnimation({
      container: this.element, // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: this.props.path // the path to the animation json
    });
  }

  componentWillReceiveProps(props) {
    this.setState({
      ...props
    });
  }

  render() {
    return (
      <div style={wrapperStyle(this.state)}>
        <div
          ref={element => {
            this.element = element;
          }}
        />
      </div>
    );
  }
}

export default AnimatedSVG;



// WEBPACK FOOTER //
// ./src/components/AnimatedSVG/index.js